import React, { useState } from 'react';
import { FaBeer } from 'react-icons/fa';
import { FaAccessibleIcon } from "react-icons/fa";
import {
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
  } from 'reactstrap';

 
   

const ChangePwd = () => {

    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const handleChange = (e) => {
        setFormData({
          ...formData,
          [e.target.name]: e.target.value,
        });
      };

    const handleSubmit = (e) => {
        e.preventDefault();
        //Console.log(formData);
    };
    
  return (
    <Form onSubmit={handleSubmit} className='Login'>
      <div className="login-head">
          <FaAccessibleIcon size={30} color="green" />
        <p>CRM Ehub</p>
      </div>
    <FormGroup>
      <Label for="Reset Pwd">Reset Password</Label>
      <Input
        type="email"
        // type="Reset Password"
        name="resetPwd"
        id="resetPwd"
        placeholder="Reset Pwd"
        value={formData.email}
        onChange={handleChange}
      />
    </FormGroup>
    <FormGroup>
      <Label for="NewPassword">New Password</Label>
      <Input
        type="Password"
        name="NewPassword"
        id="NewPassword"
        placeholder="XXXXXXXXXXX"
        value={formData.email}
        onChange={handleChange}
      />
    </FormGroup>
    <FormGroup>
      <Label for="ConfirmPassword">Confirm Password</Label>
      <Input
        type="Reset Password"
        name="confirmPassword"
        id="confirmPassword"
        placeholder="XXXXXXXXXXX"
        value={formData.email}
        onChange={handleChange}
      />
    </FormGroup>

    <div className="login-footer">
      <Button type="submit" className='login-btn'>
        Change Pasword
      </Button>
      <a href="/forgot-password" className="forgot-password">
        Login
      </a>
  </div>
  </Form>
  )
}

export default ChangePwd